import React, { useState, useMemo, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Button,
} from "reactstrap";
import TableContainer from "../../../Components/Common/TableContainer";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withTranslation } from "react-i18next";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import axiosInstance from "../../../axiosConfig";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function calcDuree(montant, montantPaiement) {
  if (!montantPaiement || montantPaiement === 0) return "-";
  return Math.ceil(montant / montantPaiement);
}
function calcDureeRestante(restant, montantPaiement) {
  if (!montantPaiement || montantPaiement === 0) return "-";
  return Math.ceil(restant / montantPaiement);
}
function daysToYMD(days) {
  const years = Math.floor(days / 365);
  days %= 365;
  const months = Math.floor(days / 30);
  days %= 30;
  return [
    years ? years + (years > 1 ? " ans" : " an") : null,
    months ? months + (months > 1 ? " mois" : " mois") : null,
    days ? days + (days > 1 ? " jours" : " jour") : null,
  ]
    .filter(Boolean)
    .join(", ");
}
function addDaysToDate(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}
function dureeAffichable(nombre, type) {
  if (!nombre || isNaN(nombre)) return "-";
  const jours = type === "journalier" ? nombre : nombre * 7;
  return daysToYMD(jours);
}

const Remboursements = (props) => {
  const [chauffeurs, setChauffeurs] = useState([]);
  const [remboursements, setRemboursements] = useState([]);
  const [loading, setLoading] = useState(true);

  const [modal, setModal] = useState(false);
  const [step, setStep] = useState("form"); // "form" ou "recap"
  const [adding, setAdding] = useState(false);

  const [newRemb, setNewRemb] = useState({
    driverId: "",
    typeEngin: "",
    montant: "",
    payé: "",
    restant: "",
    typeRemboursement: "",
    montantPaiement: "",
    nbrePenalite: "",
    montantPenalite: "",
  });

  const fetchDataDetail = async () => {
      try {
        const driverList = await axiosInstance.get(`/driverlist/`);
      //   console.log("driverList: ", driverList);
        if (driverList?.data) {
          setChauffeurs(driverList.data.data);
        }
      } catch (err) {
      //   console.log(err);
      }
      setLoading(false);
    };
  
    useEffect(() => {
      fetchDataDetail();
    }, []);

  const handleaccept = (idChauffeur) => {
      // axios.put( `https://stepnode.inawo.pro/driveretat/?id=${ e }`, {
      axiosInstance
        .put(`/driveretat/?id=${idChauffeur}`, {
          etat: "Activer",
          motif: null,
        })
        .then((res) => {
        //   console.log(res);
          toast.success("Chauffeur activé avec succès");
          fetchDataDetail();
        })
        .catch((err) => {
        //   console.log(err);
          toast.error("Erreur lors de l'activation du chauffeur");
        });
    };

  // Chargement des chauffeurs & remboursements à l'ouverture
  // Chargement des chauffeurs
  useEffect(() => {
    const fetchDrivers = async () => {
      setLoading(true);
      try {
        const driversRes = await axiosInstance.get("/driverlist/");
        if (driversRes.data?.data && Array.isArray(driversRes.data.data)) {
          const drivers = driversRes.data.data.map((item) => ({
            label:
              item.first_name && item.last_name
                ? `${item.first_name} ${item.last_name}`
                : item.username || item.telephone || "Chauffeur",
            value: item.user_id,
            id: item.id,
            type_engin: item.type_engin,
            ...item,
          }));
          setChauffeurs(drivers);
        }
      } catch (err) {
        console.error("Erreur chargement chauffeurs:", err);
        toast.error("Erreur lors du chargement des chauffeurs");
      }
    };
    fetchDrivers();
  }, []);

// Chargement des remboursements
useEffect(() => {
  const fetchRemboursements = async () => {
    try {
      const rembRes = await axiosInstance.get("/allremboursement/");
      if (rembRes.data && Array.isArray(rembRes.data)) {
        const mapped = rembRes.data.map((plan) => ({
          id: plan.plan_id,
          conducteur_id: plan.conducteur_id,
          user_id: plan.user_id,
          driverName: `${plan.first_name || ""} ${plan.last_name || ""}`.trim(),
          typeEngin: plan.type_engin,
          montant: Number(plan.montant_total),
          payé: Number(plan.montant_deja_paye),
          restant: Number(plan.montant_restant),
          typeRemboursement: plan.frequence_paiement,
          montantPaiement: Number(plan.montant_a_paye),
          nbrePenalite: Number(plan.nombre_penalites),
          montantPenalite: Number(plan.montant_penalites),
          debutPlan: plan.debut_plan,
          delaiFin: plan.delai_fin,
          joursRestants: plan.jours_restants,
        }));
        setRemboursements(mapped);
      }
    } catch (err) {
      console.error("Erreur chargement remboursements:", err);
      console.log("Données reçues:", err?.response?.data);
      if (err?.response?.data.error === "Nous ne retrouvons pas de remboursement.") {
        // Si pas de remboursements, on laisse remboursements vide
        setRemboursements([]);
      }
      else{
        toast.error("Erreur lors du chargement des remboursements");
      }
    } finally {
      setLoading(false);
    }
  };
  fetchRemboursements();
}, []);

  const tousChampsPourCalcul =
    newRemb.montant &&
    newRemb.typeRemboursement &&
    newRemb.montantPaiement &&
    Number(newRemb.montantPaiement) > 0;

  const dureeTotalEcheances = tousChampsPourCalcul
    ? Math.ceil(Number(newRemb.montant) / Number(newRemb.montantPaiement))
    : 0;

  const dureeTotalJours =
    newRemb.typeRemboursement === "hebdomadaire"
      ? dureeTotalEcheances * 7
      : dureeTotalEcheances;

  const dureeLisible = tousChampsPourCalcul
    ? dureeAffichable(dureeTotalEcheances, newRemb.typeRemboursement)
    : "";

  const dateDebut = new Date();
  const dateFin =
    tousChampsPourCalcul && dureeTotalJours > 0
      ? addDaysToDate(dateDebut, dureeTotalJours)
      : null;

  const [isExportCSV, setIsExportCSV] = useState(false);

  const columns = useMemo(
    () => [
      {
        Header: "Chauffeur",
        accessor: "driverName",
      },
      {
        Header: "Type d'engin",
        accessor: "typeEngin",
      },
      {
        Header: "Montant total (XOF)",
        accessor: "montant",
      },
      {
        Header: "Déjà payé (XOF)",
        accessor: "payé",
      },
      {
        Header: "Restant (XOF)",
        accessor: "restant",
      },
      {
        Header: "Fréquence ",
        accessor: "typeRemboursement",
        Cell: ({ row }) =>
          row.original.typeRemboursement === "journalier"
            ? "Journalier"
            : "Hebdomadaire",
      },
      {
        Header: "Montant paiement (XOF)",
        accessor: "montantPaiement",
      },
      {
        Header: "Pénalités",
        accessor: "nbrePenalite",
        Cell: ({ row }) => {
          const nbre = Number(row.original.nbrePenalite || 0);
          const montantUnitaire = Number(row.original.montantPenalite || 0);
          const montantTotal = nbre * montantUnitaire;
          return (
            <span>
              {nbre} pénalit{nbre > 1 ? "és" : "é"}
              <br />
              <small className="text-muted">
                Total&nbsp;: {montantTotal.toLocaleString()} XOF
              </small>
            </span>
          );
        },
      },
      {
        Header: "Durée totale",
        accessor: "dureeTotale",
        Cell: ({ row }) => {
          const raw = calcDuree(
            row.original.montant,
            row.original.montantPaiement
          );
          return (
            <span>
              {raw}{" "}
              {row.original.typeRemboursement === "journalier"
                ? "jours"
                : "sem."}{" "}
              <br />
              <small className="text-muted">
                {dureeAffichable(raw, row.original.typeRemboursement)}
              </small>
            </span>
          );
        },
      },
      {
        Header: "Durée restante",
        accessor: "dureeRestante",
        Cell: ({ row }) => {
          const raw = calcDureeRestante(
            row.original.restant,
            row.original.montantPaiement
          );
          return (
            <span>
              {raw}{" "}
              {row.original.typeRemboursement === "journalier"
                ? "jours"
                : "sem."}{" "}
              <br />
              <small className="text-muted">
                {dureeAffichable(raw, row.original.typeRemboursement)}
              </small>
            </span>
          );
        },
      },
      {
        Header: props.t("Action"),
        Cell: (cellProps) => {
          const remboursementData = cellProps.row.original;
          return (
            <ul className="list-inline justify-content-center hstack gap-2 mb-0">
              <li className="list-inline-item" title={props.t("Voir")}>
                <Link
                  to={`/remboursements-detail/${remboursementData.user_id}`}
                  className="text-success d-inline-block"
                  onClick={() => {
                    const remboursementData = cellProps.row.original;
                  }}
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    []
  );

  const toggle = useCallback(() => {
    setModal((prev) => !prev);
    setStep("form");
    setAdding(false);
    setNewRemb({
      driverId: "",
      typeEngin: "",
      montant: "",
      payé: "",
      restant: "",
      typeRemboursement: "",
      montantPaiement: "",
      nbrePenalite: "",
      montantPenalite: "",
    });
  }, []);

  const driversDispos = chauffeurs.filter(
    (driver) =>
      !remboursements.some(
        (plan) => Number(plan.conducteur_id) === Number(driver.id)
      )
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAdding(true);

    const restant = Number(newRemb.montant) - Number(newRemb.payé || 0);

    const dataToSend = {
      conducteur_id: Number(newRemb.driverId),
      type_engin: newRemb.typeEngin,
      montant_total: Number(newRemb.montant),
      montant_deja_paye: Number(newRemb.payé || 0),
      montant_restant: restant,
      frequence_paiement: newRemb.typeRemboursement,
      montant_a_paye: Number(newRemb.montantPaiement),
      nombre_penalites: Number(newRemb.nbrePenalite || 0),
      montant_penalites: Number(newRemb.montantPenalite || 0),
    };

    try {
      const response = await axiosInstance.post(
        "/addplanremboursement/",
        dataToSend
      );
      const rembRes = await axiosInstance.get("/allremboursement/");
      if (rembRes.data && Array.isArray(rembRes.data)) {
        const mapped = rembRes.data.map((plan) => ({
          id: plan.plan_id,
          conducteur_id: plan.conducteur_id,
          driverName: `${plan.first_name || ""} ${plan.last_name || ""}`.trim(),
          typeEngin: plan.type_engin,
          montant: Number(plan.montant_total),
          payé: Number(plan.montant_deja_paye),
          restant: Number(plan.montant_restant),
          typeRemboursement: plan.frequence_paiement,
          montantPaiement: Number(plan.montant_a_paye),
          nbrePenalite: Number(plan.nombre_penalites),
          montantPenalite: Number(plan.montant_penalites),
          debutPlan: plan.debut_plan,
          delaiFin: plan.delai_fin,
          joursRestants: plan.jours_restants,
        }));
        setRemboursements(mapped);
      }
      toast.success("Plan de remboursement ajouté !");
      toggle();
    } catch (error) {
      toast.error("Erreur lors de l'ajout du plan de remboursement.");
      console.error(error);
    }
    setAdding(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={"Plans de remboursement"} pageTitle="Takci" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-end">
                    <div className="flex-shrink-0">
                      <button
                        className="btn add-btn"
                        style={{ background: "#002437", color: "white" }}
                        onClick={toggle}
                      >
                        <i className="ri-user-add-line me-1 align-bottom"></i>
                        Ajouter un plan de remboursement
                      </button>
                      <button
                        className="btn"
                        style={{ color: "#eac22f" }}
                        disabled={remboursements.length === 0}
                        onClick={() => setIsExportCSV(true)}
                      >
                        <i className="ri-file-download-line align-bottom me-1"></i>
                        Export
                      </button>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={12}>
              <Card id="remboursementList">
                <CardBody className="pt-0">
                  <div>
                    <ExportCSVModal
                      show={isExportCSV}
                      onCloseClick={() => setIsExportCSV(false)}
                      data={remboursements}
                    />
                    {loading ? (
                      <div className="text-center py-5">
                        <span className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }}></span>
                        <div className="mt-3">Chargement en cours...</div>
                      </div>
                    ) : remboursements.length === 0 ? (
                      <div className="text-center py-5">
                        <div className="text-muted">
                          <i className="ri-file-list-3-line" style={{ fontSize: '3rem' }}></i>
                          <h5 className="mt-3">Aucun plan de remboursement disponible</h5>
                          <p>Commencez par ajouter un nouveau plan de remboursement.</p>
                        </div>
                      </div>
                    ) : (
                      <TableContainer
                        columns={columns}
                        data={remboursements}
                        isGlobalFilter={true}
                        isAddUserList={false}
                        customPageSize={8}
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-3"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                        handleChauffeurClick={toggle}
                      />
                    )}
                  </div>
                  <Modal
                    id="showModal"
                    style={{ maxWidth: 800 }}
                    isOpen={modal}
                    centered
                    toggle={toggle}
                  >
                    <ModalHeader className="bg-soft-info p-3">
                      Ajouter un plan de remboursement
                    </ModalHeader>
                    {step === "form" ? (
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (
                            !newRemb.driverId ||
                            !newRemb.typeEngin ||
                            !newRemb.montant ||
                            !newRemb.typeRemboursement ||
                            !newRemb.montantPaiement
                          ) {
                            toast.error(
                              "Tous les champs obligatoires doivent être remplis."
                            );
                            return;
                          }
                          setStep("recap");
                        }}
                      >
                        <ModalBody>
                          <Row className="g-3">
                            <Col lg={6}>
                              <Label>Chauffeur *</Label>
                              <Input
                                type="select"
                                value={newRemb.driverId}
                                onChange={(e) => {
                                  const id = Number(e.target.value);
                                  const selectedDriver = chauffeurs.find(
                                    (ch) => Number(ch.value) === id
                                  );
                                  setNewRemb((s) => ({
                                    ...s,
                                    driverId: id,
                                    typeEngin:
                                      selectedDriver && selectedDriver.type_engin
                                        ? selectedDriver.type_engin
                                        : "Indéfini",
                                  }));
                                }}
                                required
                              >
                                <option value="">Sélectionnez un chauffeur</option>
                                {driversDispos.length === 0 ? (
                                  chauffeurs.map((d) => (
                                    <option key={d.value} value={d.value}>
                                      {d.label}
                                    </option>
                                  ))
                                ) : (
                                  driversDispos.map((d) => (
                                    <option key={d.value} value={d.value}>
                                      {d.label}
                                    </option>
                                  ))
                                )}
                              </Input>
                            </Col>
                            <Col lg={6}>
                              <Label>Type d'engin</Label>
                              <Input
                                type="text"
                                value={newRemb.typeEngin}
                                disabled
                                readOnly
                              />
                            </Col>
                            <Col lg={4}>
                              <Label>Montant total à rembourser (XOF) *</Label>
                              <Input
                                type="number"
                                value={newRemb.montant}
                                onChange={(e) =>
                                  setNewRemb((s) => ({
                                    ...s,
                                    montant: e.target.value,
                                  }))
                                }
                                required
                              />
                            </Col>
                            <Col lg={4}>
                              <Label>Fréquence de remboursement *</Label>
                              <Input
                                type="select"
                                value={newRemb.typeRemboursement}
                                onChange={(e) =>
                                  setNewRemb((s) => ({
                                    ...s,
                                    typeRemboursement: e.target.value,
                                  }))
                                }
                                required
                              >
                                <option value="">Choisir</option>
                                <option value="journalier">Journalier</option>
                                <option value="hebdomadaire">
                                  Hebdomadaire
                                </option>
                              </Input>
                            </Col>
                            <Col lg={4}>
                              <Label>
                                Montant par échéance (XOF) *
                              </Label>
                              <Input
                                type="number"
                                value={newRemb.montantPaiement}
                                onChange={(e) =>
                                  setNewRemb((s) => ({
                                    ...s,
                                    montantPaiement: e.target.value,
                                  }))
                                }
                                required
                              />
                              {tousChampsPourCalcul && (
                                <div
                                  style={{ fontSize: "0.85em", marginTop: 8 }}
                                >
                                  <strong>Durée totale estimée :</strong>{" "}
                                  {dureeLisible} ({dureeTotalEcheances}{" "}
                                  {newRemb.typeRemboursement === "hebdomadaire"
                                    ? "semaines"
                                    : "jours"}
                                  )
                                  <br />
                                  <strong>Date de fin estimée :</strong>{" "}
                                  {dateFin
                                    ? dateFin.toLocaleDateString("fr-FR", {
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                      })
                                    : "-"}
                                </div>
                              )}
                            </Col>
                          </Row>
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            type="button"
                            className="btn-light"
                            onClick={toggle}
                          >
                            Fermer
                          </Button>
                          <Button
                            type="submit"
                            className="btn"
                            style={{ background: "#002437", color: "white" }}
                          >
                            Suivant
                          </Button>
                        </ModalFooter>
                      </Form>
                    ) : (
                      <Form onSubmit={handleSubmit}>
                        <ModalBody>
                          <h5 className="mb-3">
                            Veuillez confirmer les informations
                          </h5>
                          <div style={{color: "red", fontWeight: "bold", marginBottom: 16}}>
                            ⚠️ La création d’un plan de remboursement est <u>irréversible</u>.<br/>
                            Veuillez vérifier soigneusement toutes les informations avant de valider !
                          </div>
                          <table className="table table-bordered">
                            <tbody>
                              <tr>
                                <th>Chauffeur</th>
                                <td>
                                  {chauffeurs.find(
                                    (ch) => ch.value === newRemb.driverId
                                  )?.label || "-"}
                                </td>
                              </tr>
                              <tr>
                                <th>Type d'engin</th>
                                <td>{newRemb.typeEngin}</td>
                              </tr>
                              <tr>
                                <th>Montant total</th>
                                <td>{newRemb.montant} XOF</td>
                              </tr>
                              <tr>
                                <th>Fréquence</th>
                                <td>{newRemb.typeRemboursement}</td>
                              </tr>
                              <tr>
                                <th>Montant paiement</th>
                                <td>{newRemb.montantPaiement} XOF</td>
                              </tr>
                              <tr>
                                <th>Durée totale</th>
                                <td>{dureeLisible}</td>
                              </tr>
                              <tr>
                                <th>Date de fin</th>
                                <td>
                                  {dateFin
                                    ? dateFin.toLocaleDateString("fr-FR")
                                    : "-"}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            type="button"
                            className="btn-light"
                            onClick={() => setStep("form")}
                          >
                            Retour
                          </Button>
                          <Button
                            type="submit"
                            className="btn"
                            style={{ background: "#002437", color: "white" }}
                            disabled={adding}
                          >
                            {adding ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Ajout...
                              </>
                            ) : (
                              "Confirmer"
                            )}
                          </Button>
                        </ModalFooter>
                      </Form>
                    )}
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer closeButton={false} />
        </Container>
      </div>
    </React.Fragment>
  );
};

Remboursements.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(Remboursements));
